// @flow
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import SnackBar from "@justpark/ui/src/components/SnackBar";
import bem from "@justpark/helpers/src/bem/bem";
import { hide } from "../../reducers/snackbar";

import "./connectedSnackBar.scss";

const ConnectedSnackBar = () => {
  const id = useSelector((state) => state.snackbar.id);
  const message = useSelector((state) => state.snackbar.message);
  const cta = useSelector((state) => state.snackbar.cta);
  const action = useSelector((state) => state.snackbar.action);
  const hasError = useSelector((state) => state.snackbar.hasError);

  const dispatch = useDispatch();

  const baseClass = "c-connected-snackbar";

  const onClick = () => {
    if (action) {
      const payload = JSON.parse(action);
      dispatch(payload);
    }
  };

  useEffect(() => {
    if (!id) {
      return () => {};
    }

    const timeout = window.setTimeout(() => {
      dispatch(hide());
    }, 10000);

    return () => {
      window.clearTimeout(timeout);
    };
  }, [id, dispatch]);

  return (
    <TransitionGroup>
      {message ? (
        <CSSTransition
          classNames={bem(baseClass)}
          key={id}
          timeout={{ enter: 375, exit: 180 }}
        >
          <div className={bem(baseClass)} key={id}>
            <SnackBar
              message={message}
              action={cta}
              onClick={onClick}
              hasError={hasError}
            />
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
};

export default ConnectedSnackBar;
